import {IOrganization} from "./organization.model";

export interface IPosition {
    id?: number;
    itemName?: string;
    status?: string;
  organization?: IOrganization;

}

export class Position implements IPosition {
    constructor(public id?: number, public itemName?: string, public status?: string
      ,  public organization?: IOrganization
    ) {}
}
